import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgG1 from './assets/g1.png';
import ImgG2 from './assets/g2.jpg';
import ImgG3 from './assets/g3.jpg';
import ImgG4 from './assets/g4.png';

import ImgEsportsOne from '../assets/EsportsOne.png';
import ImgTwitch from '../assets/Twitch.png';

export default class GnostMono extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='Gnost Mono'
            year='2014'
            exploration='Type Design'
          />
          <div className={css.content}>
            <img src={ImgG1} alt='Gnost Mono' />
            <div className={css.text}>
              <p>Gnost Mono is a monospaced typeface designed for use in GUI text editors. Gnost Mono takes its name from gnosis, the ancient greek word for knowledge.</p>
            </div>
            <img src={ImgG2} alt='Glyphs' />
            <img src={ImgG3} alt='Process' />
            <img src={ImgG4} alt='Samples' />
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='Twitch'
                  description='Positioning Twitch as the premier destination for mobile gamers'
                  position='Senior Product Designer'
                  img={ImgTwitch}
                  link='Twitch'
                />
                <ProjectItem
                  title='Esports One Design System'
                  description='Figma design system for an esports startup'
                  position='Freelance Product Designer'
                  img={ImgEsportsOne}
                  link='EsportsOne'
                />
              </ul>
          </div>
        </div>
      )
   }
}
